import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'
import trim from 'validator/lib/trim'

import FormStudent from './form-student'
import { saveStudent } from './actions'

class FormContainer extends Component {

  _onSubmit = (payload) => {
    const { dispatch } = this.props
    // auto set username if not set
    if (!payload.get('username')) {
      // username = firstname.lastname
      let username = `${trim(payload.get('first_name'))}.${trim(payload.get('last_name'))}`
      username = username.split(' ').join('.')
      payload = payload.set('username', username)
    }
    dispatch(saveStudent(payload))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('studentState', fromJS(res.payload)))
          this.context.router.push(`/students/${res.payload.id}`)
        }
      })
  }

  render() {
    return (
      <FormStudent onSubmit={this._onSubmit} />
    )
  }
}

FormContainer.contextTypes = {
  router: PropTypes.object,
}

FormContainer.propTypes = {
  dispatch: PropTypes.func,
}

export default connect()(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Students/form-container.js